export default (micros: number | string) => Number(micros) / 1000000;
